import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const PHONE = "07936697351";
export const EMAIL = "CABLE.STREETWLV@GMAIL.COM";
export const EBAY = "https://www.ebay.co.uk/str/cbls";
export const PAY_METHODS = ["Card", "Apple Pay", "PayPal", "Klarna"];
export const waLink = (text = "Hi CBLS AIRBAGS, I have a question about an airbag.") =>
  `https://wa.me/447936697351?text=${encodeURIComponent(text)}`;

export const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1591388156010-dd522151da35?w=1200&q=80";
export const imgUrl = (p) => (!p ? FALLBACK_IMG : p.startsWith("http") ? p : `${API}/files/${p}`);

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(n) || 0);

export const TYPES = [
  { value: "driver", label: "Driver airbags" },
  { value: "passenger", label: "Passenger airbags" },
  { value: "knee", label: "Knee airbags" },
  { value: "curtain", label: "Curtain airbags" },
  { value: "side", label: "Side airbags" },
  { value: "seat", label: "Seat airbags" },
  { value: "kit", label: "Airbag kits" },
  { value: "dashboard", label: "Dashboards" },
  { value: "seatbelt", label: "Seat belts & pretensioners" },
  { value: "module", label: "SRS modules & sensors" },
];
export const typeLabel = (v) => TYPES.find((t) => t.value === v)?.label ?? v;

export const DELIVERY_TEXT = {
  dashboard: "Dashboards: £70 delivery. Dispatched after 1 working day, arrives in 2-3 working days.",
  standard: "Standard £4.99 (2-3 working days) or Express £14.99 (dispatched after 1 working day, arrives in 1-2 days).",
};
export const deliveryText = (type) => (type === "dashboard" ? DELIVERY_TEXT.dashboard : DELIVERY_TEXT.standard);

export const years = (p) =>
  p?.year_from ? `${p.year_from}${p.year_to ? `–${p.year_to}` : "+"}` : "";

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}
